import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons'

import Card from '../../../utils/Card'
import { SURVEY_WHO } from '../../../../utils/constants'
import clsx from 'clsx'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

const CheckboxToggle = ({ label, checked, onChange, ...props }) => {
  return (
    <label
      className={clsx(
        'flex justify-start align-start space-x-2 p-2 rounded-lg cursor-pointer bg-gray-50 border border-gray-300 mb-1',
        checked && 'bg-green-100'
      )}
      onClick={onChange}
    >
      <div className="select-none text-lg text-gray-700 font-normal leading-snug">{label}</div>
    </label>
  )
}

const PremiumMember = () => {
  const dispatch = useDispatch()
  const handleAnswerChange = (questionNumber, answerNumber) => {
    dispatch(push(`/survey/${answerNumber}`))
  }

  return (
    <Card className="mt-4" color="darkGreen">
      <div className="text-center mb-4 text-2xl font-bold">
        <h3 className="inline md:hidden lg:inline ">Wandering Labs Survey</h3>
        <h3 className="hidden md:inline lg:hidden">Wandering Labs Survey</h3>
      </div>
      <div>
        {SURVEY_WHO.slice(0, 1).map((question, questionNumber) => (
          <div key={questionNumber} className="mb-8">
            <h3 className={clsx('mb-4 font-semibold text-lg leading-snug')}>{question.question}</h3>
            {question.answers.map((answer, answerNumber) => (
              <div key={answerNumber}>
                <CheckboxToggle
                  label={answer}
                  checked={false}
                  onChange={() => handleAnswerChange(questionNumber, answerNumber)}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </Card>
  )
}

export default PremiumMember
